const EMAIL_REGEX = /^[a-zA-Z0-9._%+&-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export default (audience) => ({
  audience,
  delivery: 1,
  touched: new Set(),

  init() {
    this.$watch('delivery', (value) => {
      this.audience.find((p) =>
        p.id == value ? (p.delivery = true) : (p.delivery = false),
      )
    })
  },

  markTouched(person) {
    this.touched.add(person.id)
  },

  emailMalformed(person) {
    return person.email.length > 0 && !EMAIL_REGEX.test(person.email)
  },

  noPurpose(person) {
    return (
      person.id != 1 &&
      person.email.length > 0 &&
      !person.order &&
      !person.invoice &&
      !person.delivery
    )
  },

  emailInvalid(person) {
    return this.touched.has(person.id) && this.emailMalformed(person)
  },

  noPurposeInvalid(person) {
    return (
      this.touched.has(person.id) &&
      !this.emailMalformed(person) &&
      this.noPurpose(person)
    )
  },

  anyRowInvalid() {
    return this.audience.some(
      (p) => this.emailMalformed(p) || this.noPurpose(p),
    )
  },
})
